import React, { useEffect, useState, useCallback } from 'react';
import { VehicleView } from './VehicleGapDetection.types';

interface SedanSVGProps {
  view: VehicleView;
  className?: string;
  onLoad?: () => void;
}

/**
 * Komponent SVG sylwetki sedana dla różnych widoków
 * Używa dynamicznego importu jak w SVGIcon
 */
export const SedanSVG: React.FC<SedanSVGProps> = ({ view, className = '', onLoad }) => {
  const [IconComponent, setIconComponent] = useState<React.FC<
    React.SVGProps<SVGSVGElement>
  > | null>(null);

  const getSvgName = useCallback(() => {
    switch (view) {
      case 'left':
        return 'sedan-lewa';
      case 'top':
        return 'sedan-gora';
      case 'right':
        return 'sedan-prawa';
    }
  }, [view]);

  const importIcon = useCallback(async () => {
    try {
      const svgName = getSvgName();
      /* @vite-ignore */
      const imported = await import(`./svg/${svgName}.svg`);
      setIconComponent(() => imported.ReactComponent);
    } catch (error) {
      console.error(`SedanSVG: Błąd podczas importowania ${view}:`, error);
    }
  }, [view, getSvgName]);

  useEffect(() => {
    importIcon();
  }, [importIcon]);

  useEffect(() => {
    if (IconComponent && onLoad) {
      onLoad();
    }
  }, [IconComponent, onLoad]);

  if (!IconComponent) {
    return <div className={className} />;
  }

  return <IconComponent className={className} />;
};
